import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import TourCard from './TourCard';
import TourCardTwo from './TourCardTwo';
import SidebarWidgets from '../Common/SidebarWidgets';
import { api } from '../../services/api';
import { useContentList } from '../../hooks/useContent';

function TourInner() {
    const [activeTab, setActiveTab] = useState('tab-grid');
    const [currentPage, setCurrentPage] = useState(1);
    const { items: posts, loading, error } = useContentList(() => api.getTours({ per_page: 100 }), []);
    const postsPerPage = 8;

    const totalPages = Math.ceil(posts.length / postsPerPage) || 1;
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    return (
        <section className="space">
            <div className="container shape-mockup-wrap">
                {loading && <p className="text-center">Loading tours...</p>}
                {error && <p className="text-center text-danger">{error}</p>}
                <div className="th-sort-bar">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-md-4">
                            <div className="search-form-area">
                                <form className="search-form">
                                    <input type="text" placeholder="Search" />
                                    <button type="submit">
                                        <i className="fa-light fa-magnifying-glass" />
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div className="col-md-auto">
                            <div className="sorting-filter-wrap">
                                <div className="nav" role="tablist">
                                    <Link
                                        to="#"
                                        id="tab-destination-grid"
                                        data-bs-toggle="tab"
                                        data-bs-target="#tab-grid"
                                        role="tab"
                                        aria-controls="tab-grid"
                                        aria-selected="true"
                                        className={`${activeTab === 'tab-grid' ? 'active' : ''}`}
                                        type="button"
                                        onClick={() => setActiveTab('tab-grid')}
                                    >
                                        <i className="fa-light fa-grid-2" />
                                    </Link>
                                    <Link
                                        to="#"
                                        id="tab-destination-list"
                                        data-bs-toggle="tab"
                                        data-bs-target="#tab-list"
                                        role="tab"
                                        aria-controls="tab-list"
                                        aria-selected="false"
                                        className={`${activeTab === 'tab-list' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('tab-list')}
                                    >
                                        <i className="fa-solid fa-list" />
                                    </Link>
                                </div>
                                <form className="woocommerce-ordering" method="get">
                                    <select
                                        name="orderby"
                                        className="orderby"
                                        aria-label="destination order"
                                    >
                                        <option value="menu_order" >
                                            Default Sorting
                                        </option>
                                        <option value="popularity">Sort by popularity</option>
                                        <option value="rating">Sort by average rating</option>
                                        <option value="date">Sort by latest</option>
                                        <option value="price">Sort by price: low to high</option>
                                        <option value="price-desc">Sort by price: high to low</option>
                                    </select>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-8 col-lg-7">
                        <div className="tab-content" id="nav-tabContent">
                            <div
                                className={`tab-pane fade ${activeTab === 'tab-grid' ? 'show active' : ''}`} id="tab-grid" role="tabpanel"
                            >
                                <div className="row gy-24 gx-24">
                                    {currentPosts.map((data, index) => (
                                        <div key={index} className="col-md-6">
                                            <TourCard
                                                tourID={data.id}
                                                tourImage={`${data.image}`}
                                                tourTitle={data.title}
                                                tourPrice={data.price}
                                                tourDuration={data.duration_days}
                                                tourLocation={data.location || data.country}
                                                tourRating={data.rating}
                                                nextDate={data.next_date}
                                                availableSlots={data.available_slots}
                                                totalSlots={data.total_slots}
                                                hasPackages={Boolean(data.has_packages || (data.packages && data.packages.length))}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'tab-list' ? 'show active' : ''}`} id="tab-list" role="tabpanel"
                            >
                                <div className="row gy-30">
                                    {currentPosts.map((data, index) => (
                                        <div key={index} className="col-12">
                                            <TourCardTwo
                                                tourID={data.id}
                                                tourImage={`${data.image}`}
                                                tourTitle={data.title}
                                                tourPrice={data.price}
                                                tourDuration={data.duration_days}
                                                tourLocation={data.location || data.country}
                                                tourRating={data.rating}
                                                nextDate={data.next_date}
                                                availableSlots={data.available_slots}
                                                totalSlots={data.total_slots}
                                                hasPackages={Boolean(data.has_packages || (data.packages && data.packages.length))}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="th-pagination text-center mt-60">
                                <ul>
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <li key={i}>
                                            <Link
                                                className={currentPage === i + 1 ? 'active' : ''}
                                                to="#"
                                                onClick={() => handlePageChange(i + 1)}
                                            >
                                                {i + 1}
                                            </Link>
                                        </li>
                                    ))}
                                    {currentPage < totalPages && (
                                        <li>
                                            <Link className="next-page" to="#" onClick={() => handlePageChange(currentPage + 1)}>
                                                Next <img src="/assets/img/icon/arrow-right4.svg" alt="" />
                                            </Link>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-lg-5">
                        <SidebarWidgets categoryType="tour" />
                    </div>
                </div>
                <div
                    className="shape-mockup shape1 d-none d-xxl-block"
                    style={{ bottom: "7%", right: "-8%" }}
                >
                    <img src="/assets/img/shape/shape_1.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup shape2 d-none d-xl-block"
                    style={{ bottom: "1%", right: "-7%" }}
                >
                    <img src="/assets/img/shape/shape_2.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup shape3 d-none d-xxl-block"
                    style={{ bottom: "-2%", right: "-12%" }}
                >
                    <img src="/assets/img/shape/shape_3.png" alt="shape" />
                </div>
            </div>
        </section>

    )
}

export default TourInner
